/**
 * Textos fixos do bloco 45 — Destaques Dinâmicos.
 *
 * Cada string abaixo NÃO é editável pelo Champion, e a razão está ao lado.
 * Rótulo que o Champion edita (ex.: "Ver mais") mora nas props, não aqui.
 */

/** aria-label da seta anterior do carrossel. Rótulo de acessibilidade, não é conteúdo editorial. */
export const ARIA_PREV = "Anterior";

/** aria-label da seta seguinte do carrossel. Idem. */
export const ARIA_NEXT = "Próximo";

/** aria-label do botão de fechar o modal. Ação do sistema, não texto de marca. */
export const ARIA_CLOSE = "Fechar";

/** aria-label do grupo de indicadores do carrossel. */
export const ARIA_INDICATOR = "Navegação do carrossel";

/** aria-label de cada dot: "Ir para o destaque N". Índice é gerado, não editável. */
export const ARIA_GO_TO = (index: number) => `Ir para o destaque ${index + 1}`;

/** Rótulo default do link de detalhes, quando o Champion não preencheu `detailsLabel`. */
export const DEFAULT_DETAILS_LABEL = "Ver mais";
